// Anita Week 9 / Day 4 — Honest Creator: Clear, Useful and Safe.
// Verbatim from FINAL Week 9 Part B (Creator) source-of-truth package.

const day4 = {
  id: 'day-4',
  studentId: 'anita',
  weekId: 'week-9',
  dayId: 'day-4',
  status: 'active',
  title: 'Честный автор: ясно, полезно, без вреда / Honest Creator: Clear, Useful and Safe',
  shortTitle: 'Честный автор / Honest Creator',
  theme: 'Анита учится проверять свой контент: он должен быть честным, понятным, полезным и безопасным. / Anita learns to check her own content: it should be honest, clear, useful and safe.',
  estimatedTimeLabel: '60–90 минут / 60–90 minutes',
  lessonTiming: { minMinutes: 60, maxMinutes: 90, breaks: 2 },
  bilingualMode: 'ru-primary-en-helper',
  readingLevel: 'grade-2',
  courseLayers: ['reading', 'math', 'creator-mindset', 'safety', 'revision', 'spelling', 'creative', 'speech'],
  nimnyIntro:
    'Нимни показывает Аните золотую карточку автора. На ней написано: «Автор не просто делает красиво. Автор делает честно, понятно, полезно и безопасно.» Сегодня Анита проверяет свои идеи как настоящий маленький автор. / Nimny shows Anita a golden creator card. It says: "A creator does not only make something pretty. A creator makes it honest, clear, useful and safe." Today Anita checks her ideas like a real young creator.',
  goals: [
    'Понять, что автор отвечает за свой контент. / Understand that a creator is responsible for their content.',
    'Проверять идею по четырём словам: честно, понятно, полезно, безопасно. / Check an idea with four words: honest, clear, useful, safe.',
    'Отличать хороший выбор автора от опасного или неполезного. / Tell good creator choices from unsafe or unhelpful ones.',
    'Решать задачи с таблицами, умножением, делением и многошаговым планом. / Solve table, multiplication, division and multi-step planning tasks.',
    'Сделать Чек-лист автора. / Make a Creator Checklist.',
    'Объяснить родителю, как автор проверяет свою работу. / Explain to parent how a creator checks their work.'
  ],
  vocabulary: [
    { term: 'автор / creator', definition: 'человек, который делает что-то полезное или понятное. / a person who makes something useful or clear.' },
    { term: 'контент / content', definition: 'рисунок, постер, карточка, видео-сценарий, guide или объяснение. / a drawing, poster, card, video script, guide or explanation.' },
    { term: 'честно / honest', definition: 'без обмана и невозможных обещаний. / without deception or impossible promises.' },
    { term: 'понятно / clear', definition: 'легко понять. / easy to understand.' },
    { term: 'полезно / useful', definition: 'помогает человеку что-то понять или сделать. / helps a person understand or do something.' },
    { term: 'безопасно / safe', definition: 'не просит личные данные, не пугает, не причиняет вред. / does not ask for personal data, does not scare, does not cause harm.' },
    { term: 'проверить / check', definition: 'посмотреть, всё ли правильно и безопасно. / look at whether everything is right and safe.' },
    { term: 'исправить / revise', definition: 'улучшить черновик. / improve the draft.' },
    { term: 'обещание / promise', definition: 'что creator обещает делать честно. / what the creator promises to do honestly.' }
  ],
  onlineTasks: [
    { id: 'reading-words', type: 'text', title: 'Задание 1 — Слова автора / Creator Words',
      prompt: 'Прочитай по-русски:\n\nавтор\nконтент\nчестно\nпонятно\nполезно\nбезопасно\nпроверить\nисправить\nобещание',
      ruPrimaryText: 'Прочитай 9 русских слов автора.',
      enHelpText: 'Read the Russian creator words first. English is only for help.',
      answer: 'Attempted Russian reading.' },
    { id: 'reading-sentences', type: 'text', title: 'Задание 2 — Маленькое чтение / Short Reading',
      prompt: 'Прочитай по-русски:\n\nАвтор делает полезное.\nЧестный контент не обманывает.\nПонятный контент легко объяснить.\nБезопасный контент не просит личные данные.',
      ruPrimaryText: 'Прочитай 4 короткие фразы о честном авторе.',
      enHelpText: 'A creator makes something useful. Honest content does not trick people. Clear content is easy to explain. Safe content does not ask for personal data.',
      answer: 'Attempted Russian reading.' },
    { id: 'creator-checklist-sort', type: 'classify', title: 'Задание 3 — Проверка автора / Creator Check',
      prompt: 'Разложи 12 карточек по категориям.\n\nКатегории:\nХороший выбор автора\nНужно проверить с родителем\nНельзя использовать\n\nКарточки:\n1. «Я объясню, как попросить помощи.»\n2. «Я покажу настоящий домашний адрес.»\n3. «Я использую добрые слова.»\n4. «Я скажу: это работает всегда и для всех.»\n5. «Я добавлю: спроси родителя.»\n6. «Я сделаю понятный рисунок с 3 шагами.»\n7. «Я попрошу отправить фото.»\n8. «Я сделаю черновик и исправлю ошибки.»\n9. «Я покажу карту вымышленного города Нимни.»\n10. «Я напишу пароль на карточке.»\n11. «Я скажу, кому это поможет.»\n12. «Я использую страшные слова, чтобы все слушали.»',
      ruPrimaryText: 'Разложи 12 карточек: хороший выбор / проверить с родителем / нельзя использовать.',
      enHelpText: 'Sort 12 cards: good creator choice / needs parent check / not allowed.',
      categories: [
        { id: 'good', label: 'Хороший выбор автора / Good creator choice' },
        { id: 'parent', label: 'Нужно проверить с родителем / Needs parent check' },
        { id: 'forbidden', label: 'Нельзя использовать / Not allowed' }
      ],
      items: [
        { id: 'c1', label: '1. «Я объясню, как попросить помощи.»', category: 'good' },
        { id: 'c2', label: '2. «Я покажу настоящий домашний адрес.»', category: 'forbidden' },
        { id: 'c3', label: '3. «Я использую добрые слова.»', category: 'good' },
        { id: 'c4', label: '4. «Я скажу: это работает всегда и для всех.»', category: 'parent' },
        { id: 'c5', label: '5. «Я добавлю: спроси родителя.»', category: 'good' },
        { id: 'c6', label: '6. «Я сделаю понятный рисунок с 3 шагами.»', category: 'good' },
        { id: 'c7', label: '7. «Я попрошу отправить фото.»', category: 'forbidden' },
        { id: 'c8', label: '8. «Я сделаю черновик и исправлю ошибки.»', category: 'good' },
        { id: 'c9', label: '9. «Я покажу карту вымышленного города Нимни.»', category: 'good' },
        { id: 'c10', label: '10. «Я напишу пароль на карточке.»', category: 'forbidden' },
        { id: 'c11', label: '11. «Я скажу, кому это поможет.»', category: 'good' },
        { id: 'c12', label: '12. «Я использую страшные слова, чтобы все слушали.»', category: 'forbidden' }
      ],
      answer: 'Хороший выбор: 1, 3, 5, 6, 8, 9, 11. Нужно проверить с родителем: 4. Нельзя использовать: 2, 7, 10, 12.' },
    { id: 'math-checklist-count', type: 'text', title: 'Задание 4 — Считаем Чек-лист автора / Count the Checklist',
      prompt: 'В Чек-лист автора было 12 карточек.\n\n7 карточек — хороший выбор.\n1 карточка — нужно проверить с родителем.\n4 карточки — нельзя использовать.\n\nОтветь:\n1. Сколько карточек всего?\n2. Сколько карточек требуют осторожности? Это «проверить» + «нельзя».\n3. На сколько хороший выбор больше, чем «нельзя использовать»?\n4. Если добавить ещё 3 хорошие карточки, сколько хороших станет?',
      ruPrimaryText: 'Реши 4 задачи про Чек-лист автора.',
      enHelpText: 'Solve 4 Чек-лист автора count problems.',
      answer: '1) 7 + 1 + 4 = 12. 2) 1 + 4 = 5. 3) 7 − 4 = 3. 4) 7 + 3 = 10.' },
    { id: 'math-creator-time', type: 'text', title: 'Задание 5 — Время на исправление / Revision Time',
      prompt: 'Анита делает полезную памятку.\n\nЧерновик занимает 12 минут.\nПроверка занимает 8 минут.\nИсправление занимает 10 минут.\nПоказ родителю занимает 5 минут.\n\nОтветь:\n1. Сколько минут занимает весь процесс?\n2. Если Анита работает 3 дня по 10 минут, хватит ли времени?\n3. Сколько минут останется или не хватит?',
      ruPrimaryText: 'Реши 3 задачи про время черновика и исправления.',
      enHelpText: 'Solve 3 draft/revision-time problems.',
      answer: '1) 12 + 8 + 10 + 5 = 35 минут. 2) 3 × 10 = 30 минут — не хватит. 3) 35 − 30 = 5 минут не хватит.' },
    { id: 'math-useful-message-groups', type: 'text', title: 'Задание 6 — Группы полезных сообщений / Useful Message Groups',
      prompt: 'Нимни делает 4 мини-постера.\nНа каждом постере по 5 полезных фраз.\nПотом она убирает 3 фразы, которые были слишком длинные.\nОставшиеся фразы она делит поровну на 5 карточек.\n\nОтветь:\n1. Сколько фраз было сначала?\n2. Сколько фраз осталось после исправления?\n3. Сколько фраз будет на каждой карточке?',
      ruPrimaryText: 'Реши 3 задачи про группы полезных фраз. Если трудно — 15 ÷ 5 = 3.',
      enHelpText: 'Solve 3 useful-message group problems. If hard, the simpler version is 15 ÷ 5 = 3.',
      answer: '1) 4 × 5 = 20. 2) 20 − 3 = 17. 3) 17 ÷ 5 = 3, остаток 2. Support: 15 ÷ 5 = 3.' },
    { id: 'safety-creator-rule', type: 'text', title: 'Задание 7 — Безопасность автора / Creator Safety',
      prompt: 'Выбери 3 правила, которые должен помнить creator.\n\nПравила:\nA. Не писать адрес, школу, пароль или телефон.\nB. Не обещать невозможное.\nC. Не показывать реальные фото без родителя.\nD. Всегда делать всё быстро и без проверки.\nE. Не просить людей писать личные данные.\nF. Публиковать всё сразу без взрослого.\n\nЗапиши 3–4 безопасных правила.',
      ruPrimaryText: 'Выбери 3–4 безопасных правила creator из 6 вариантов.',
      enHelpText: 'Pick 3–4 safe creator rules from the 6 options.',
      answer: 'Безопасные правила: A, B, C, E. D и F — не безопасные.' },
    { id: 'spelling-creator', type: 'text', title: 'Задание 8 — Правописание / Spelling',
      prompt: 'Напиши:\n\nчестно\nполезно\nпонятно\nбезопасно\nпроверить\n\nВставь буквы:\n\nч_стно\nпол_зно\nпон_тно\nбезоп_сно\nпров_рить',
      ruPrimaryText: 'Напиши 5 слов и вставь пропущенные буквы.',
      enHelpText: 'Write 5 words and fill in the missing letters.',
      answer: 'честно, полезно, понятно, безопасно, проверить.' },
    { id: 'creative-creator-checklist', type: 'text', title: 'Задание 9 — Мой Чек-лист автора / My Creator Checklist',
      prompt: 'Сделай памятку «Мой Чек-лист автора».\n\nНа карточке напиши 4 вопроса:\n\n1. Это честно?\n2. Это понятно?\n3. Это полезно?\n4. Это безопасно?\n\nНарисуй Нимни, которая проверяет черновик.',
      ruPrimaryText: 'Сделай памятку «Мой Чек-лист автора» с 4 вопросами и рисунком.',
      enHelpText: 'Make a "My Чек-лист автора" card with 4 questions and a drawing.',
      answer: 'Open-ended. Accept if Anita writes or traces 4 questions and draws a creator-check picture.' },
    { id: 'speech-honest-creator', type: 'text', title: 'Задание 10 — Объясни родителю / Explain to Parent',
      prompt: 'Скажи родителю по-русски:\n\nЯ автор полезного.\nЯ проверяю: честно, понятно, полезно, безопасно.\nЕсли черновик не идеальный, я могу исправить.',
      ruPrimaryText: 'Скажи родителю 3 фразы честного автора.',
      enHelpText: 'Say the 3 honest-creator phrases to the parent in Russian.',
      answer: 'Accept if Anita says the creator-check idea in Russian with support.' }
  ],
  notebookInstructions: [
    'Если нет принтера:',
    '1. Напиши слова дня.',
    '2. Прочитай 4 фразы.',
    '3. Разложи 12 карточек Чек-лист автора устно с родителем.',
    '4. Реши 3 math-задачи.',
    '5. Напиши 3–4 безопасных правила creator.',
    '6. Напиши 5 слов правописания.',
    '7. Сделай памятку «Мой Чек-лист автора».',
    '8. Объясни родителю 4 вопроса creator.'
  ],
  printWorksheet: {
    title: 'Честный автор: ясно, полезно, без вреда / Honest Creator: Clear, Useful and Safe',
    subtitle: 'Неделя 9 · День 4 / Week 9 · Day 4',
    pages: [
      { title: 'Честный автор / Honest Creator',
        blocks: [
          { type: 'text', text: 'Имя: __________________________   Дата: __________________________' },
          { type: 'text', text: 'Миссия: Сегодня Нимни учит Аниту проверять свой контент. Автор делает не просто красиво, а честно, понятно, полезно и безопасно.' },
          { type: 'text', text: 'Задание 1 — Слова автора. Прочитай и обведи:' },
          { type: 'list', items: [
            'автор / creator',
            'контент / content',
            'честно / honest',
            'понятно / clear',
            'полезно / useful',
            'безопасно / safe',
            'проверить / check',
            'исправить / revise',
            'обещание / promise'
          ] },
          { type: 'text', text: 'Задание 2 — Маленькое чтение. Поставь галочку:' },
          { type: 'list', items: [
            '□ Автор делает полезное.',
            '□ Честный контент не обманывает.',
            '□ Понятный контент легко объяснить.',
            '□ Безопасный контент не просит личные данные.'
          ] },
          { type: 'text', text: 'English help: A creator makes something useful. Honest content does not trick people. Clear content is easy to explain. Safe content does not ask for personal data.' },
          { type: 'text', text: 'Задание 3 — Проверка автора. A = хороший выбор, B = проверить с родителем, C = нельзя использовать.' },
          { type: 'list', items: [
            '1. «Я объясню, как попросить помощи.» ____',
            '2. «Я покажу настоящий домашний адрес.» ____',
            '3. «Я использую добрые слова.» ____',
            '4. «Я скажу: это работает всегда и для всех.» ____',
            '5. «Я добавлю: спроси родителя.» ____',
            '6. «Я сделаю понятный рисунок с 3 шагами.» ____',
            '7. «Я попрошу отправить фото.» ____',
            '8. «Я сделаю черновик и исправлю ошибки.» ____',
            '9. «Я покажу карту вымышленного города Нимни.» ____',
            '10. «Я напишу пароль на карточке.» ____',
            '11. «Я скажу, кому это поможет.» ____',
            '12. «Я использую страшные слова, чтобы все слушали.» ____'
          ] }
        ] },
      { title: 'Математика автора / Creator Math',
        blocks: [
          { type: 'text', text: 'Задание 4 — Считаем Чек-лист автора. Хороший выбор — 7, проверить с родителем — 1, нельзя использовать — 4.' },
          { type: 'list', items: [
            '1. Всего карточек: 7 + 1 + 4 = ______',
            '2. Осторожность: 1 + 4 = ______',
            '3. Хороший выбор больше «нельзя» на: 7 − 4 = ______',
            '4. Добавили 3 хорошие карточки: 7 + 3 = ______'
          ] },
          { type: 'text', text: 'Задание 5 — Время на исправление. Черновик 12 мин, проверка 8 мин, исправление 10 мин, показ 5 мин.' },
          { type: 'list', items: [
            '1. Всего минут: 12 + 8 + 10 + 5 = ______',
            '2. 3 дня по 10 минут: 3 × 10 = ______',
            '3. Хватит ли 30 минут? да / нет',
            '4. Сколько минут не хватает или остаётся? ______'
          ] },
          { type: 'text', text: 'Задание 6 — Группы полезных сообщений. Считаем:' },
          { type: 'list', items: [
            '4 постера × 5 фраз = ______ фраз',
            'Убрали 3 длинные: ______ − 3 = ______',
            'Делим на 5 карточек: ______ ÷ 5 = ______ ост. ______',
            'Если трудно — 15 ÷ 5 = ______'
          ] }
        ] },
      { title: 'Чек-лист автора',
        blocks: [
          { type: 'text', text: 'Задание 7 — Безопасность автора. Выбери безопасные правила (A, B, C, D, E, F). Запиши безопасные буквы: ____________________' },
          { type: 'list', items: [
            'A. Не писать адрес, школу, пароль или телефон.',
            'B. Не обещать невозможное.',
            'C. Не показывать реальные фото без родителя.',
            'D. Всегда делать всё быстро и без проверки.',
            'E. Не просить людей писать личные данные.',
            'F. Публиковать всё сразу без взрослого.'
          ] },
          { type: 'text', text: 'Задание 8 — Правописание. Напиши и вставь буквы:' },
          { type: 'list', items: ['честно   полезно   понятно   безопасно   проверить', 'ч_стно   пол_зно   пон_тно   безоп_сно   пров_рить'] },
          { type: 'text', text: 'Задание 9 — Мой Чек-лист автора. Напиши 4 вопроса:' },
          { type: 'list', items: [
            '1. Это честно? ____________________',
            '2. Это понятно? ____________________',
            '3. Это полезно? ____________________',
            '4. Это безопасно? ____________________'
          ] },
          { type: 'text', text: 'Нарисуй Нимни, которая проверяет черновик:' },
          { type: 'list', items: ['____________________________________', '____________________________________', '____________________________________'] },
          { type: 'text', text: 'Задание 10 — Объясни родителю. Поставь галочку:' },
          { type: 'list', items: [
            '□ Я автор полезного.',
            '□ Я проверяю: честно, понятно, полезно, безопасно.',
            '□ Если черновик не идеальный, я могу исправить.'
          ] },
          { type: 'text', text: 'Parent Check: □ Прочитала слова  □ Прочитала 4 фразы  □ Разложила карточки автора  □ Решила math tasks  □ Сделала Чек-лист автора  □ Объяснила родителю.' },
          { type: 'text', text: 'Notebook Mode — если нет принтера, сделай эти задания в тетради.' }
        ] }
    ]
  },
  parentGuide: {
    goal: 'Анита понимает, что автор проверяет свой контент: честно, понятно, полезно, безопасно.',
    mathGoal: 'Сложение категорий, вычитание, умножение 3 × 10, многошаговое сложение времени, деление с остатком как stretch.',
    russianGoal: 'Прочитать слова автор, контент, честно, понятно, полезно, безопасно, проверить, исправить, обещание.',
    readingWritingGoal: 'Прочитать 4 фразы, написать 5 слов, создать Чек-лист автора.',
    practicalGoal: 'Научиться проверять черновик перед показом родителю.',
    parentTheoryCard: {
      title: 'Как объяснить ответственность автора',
      purpose: 'Помочь родителю объяснить, что creator не просто делает красиво, а думает о пользе, ясности, честности и безопасности.',
      keyMessage: 'Автор отвечает за то, что он показывает. Хороший автор проверяет: честно, понятно, полезно, безопасно.',
      parentScript: [
        '«Автор — это не просто человек, который что-то нарисовал.»',
        '«Автор думает: кому это поможет?»',
        '«Автор не обещает невозможное.»',
        '«Автор не просит личные данные.»',
        '«Черновик можно исправлять. Исправление — часть создания.»'
      ],
      practiceSteps: [
        'Прочитайте 4 creator questions.',
        'Разберите 3 карточки выбора.',
        'Попросите Аниту сказать, почему одна карточка безопасная, а другая нет.',
        'Попросите сделать маленький Чек-лист автора.'
      ],
      doNotSay: [
        'Не говорить: «С первого раза должно быть идеально.»',
        'Не говорить: «Главное, чтобы было красиво.»',
        'Не разрешать писать реальные адреса, пароли, школы или фото.'
      ],
      paperOnlyNotes: [
        'Чек-лист автора можно делать в тетради.',
        'Реальные имена людей не нужны.',
        'Показывать проект можно родителю, не публиковать онлайн.'
      ]
    },
    whatThisLessonTeaches: 'Анита учится отвечать за свой продукт и проверять его перед показом.',
    keyMessage: 'Автор делает полезное и безопасное, а не просто красивое.',
    howToExplain: 'Скажите: «Перед тем как показать свою работу, creator задаёт 4 вопроса: честно? понятно? полезно? безопасно?»',
    exampleDialogue:
      'Parent: Если ты сделала постер, что нужно проверить?\nChild: Честно, понятно, полезно, безопасно.\nParent: Если там есть адрес?\nChild: Нельзя.\nParent: Если черновик не идеальный?\nChild: Можно исправить.',
    readingSupport: 'Слова «безопасно», «исправить», «обещание» читать по частям.',
    russianSpeechGoal: 'Анита говорит: «Я проверяю: честно, понятно, полезно, безопасно.»',
    mathAnswerKey:
      'math-checklist-count: 1) 12. 2) 5. 3) 3. 4) 10.\nmath-creator-time: 1) 35 минут. 2) 30 минут, не хватит. 3) Не хватает 5 минут.\nmath-useful-message-groups: 1) 20. 2) 17. 3) 17 ÷ 5 = 3 ост. 2. Support: 15 ÷ 5 = 3.',
    spellingAnswerKey: 'честно\nполезно\nпонятно\nбезопасно\nпроверить',
    answerKey: [
      { taskId: 'reading-words', answer: 'Попытка русского чтения.' },
      { taskId: 'reading-sentences', answer: 'Попытка русского чтения.' },
      { taskId: 'creator-checklist-sort', answer: 'good: 1,3,5,6,8,9,11; parent check: 4; do not use: 2,7,10,12.' },
      { taskId: 'math-checklist-count', answer: '12; 5; 3; 10.' },
      { taskId: 'math-creator-time', answer: '35; 30 no; 5 minutes missing.' },
      { taskId: 'math-useful-message-groups', answer: '20; 17; 3 remainder 2.' },
      { taskId: 'safety-creator-rule', answer: 'A, B, C, E.' },
      { taskId: 'spelling-creator', answer: 'честно, полезно, понятно, безопасно, проверить.' },
      { taskId: 'creative-creator-checklist', answer: '4 creator questions + drawing.' },
      { taskId: 'speech-honest-creator', answer: 'Russian explanation attempted.' }
    ],
    check: [
      'Анита прочитала слова и фразы.',
      'Анита отсортировала карточки автора.',
      'Анита решила math tasks.',
      'Анита сделала Чек-лист автора.',
      'Анита сказала 4 creator questions.'
    ],
    spellingCheck: 'Проверить честно, полезно, понятно, безопасно, проверить.',
    readingCheck: 'Главное — попытка русского чтения и понимание 4 creator words.',
    practicalCheck: 'Анита должна понять, что creator проверяет свою работу перед показом.',
    drawingCriteria: 'Есть 4 вопроса creator checklist и рисунок проверки черновика.',
    commonMistakes: [
      '«Creator — это просто красиво.» Правильно: «Creator делает полезно и безопасно.»',
      '«Черновик плохой, если есть ошибки.» Правильно: «Черновик нужен, чтобы исправлять.»',
      '«Можно показать всё сразу.» Правильно: «Сначала проверить с родителем.»',
      '«Можно писать адрес для примера.» Правильно: «Реальные данные не писать.»'
    ],
    discussionPrompts: [
      'Что значит честный контент?',
      'Почему creator не просит личные данные?',
      'Почему исправление — это часть работы?',
      'Какой вопрос creator самый важный?'
    ],
    ifEasy: 'Попросить Аниту проверить один старый рисунок или карточку по 4 вопросам creator.',
    ifDifficult: 'Оставить только два вопроса: это полезно? это безопасно?',
    rewardGuidance: 'Базовая награда — 3 нима. Бонус за аккуратный Чек-лист автора или ясное объяснение.',
    tokenReward: 'Нимы — это призовые токены курса, а не оплата.',
    parentOnlyNotes: 'Не публиковать работу онлайн. Не вводить личные данные. Не превращать creator check в критику личности ребёнка.',
    safetyNotes: 'Только бумажный/домашний проект. Без фото, адресов, школ, паролей, публикаций, сообщений незнакомцам или аккаунтов.'
  },
  reward: { unit: 'nim', unitName: 'ним', base: 3, max: 5, label: 'Награда за миссию', display: '3 нима',
    bonuses: [
      { id: 'neat-checklist', label: 'Бонус за аккуратный Чек-лист автора', amount: 1 },
      { id: 'clear-check-explain', label: 'Бонус за ясное объяснение «честно, понятно, полезно, безопасно»', amount: 1 }
    ] },
  completionRequirements: {
    requiredTaskIds: ['reading-words', 'reading-sentences', 'creator-checklist-sort', 'math-checklist-count', 'math-creator-time', 'math-useful-message-groups', 'safety-creator-rule', 'spelling-creator', 'creative-creator-checklist', 'speech-honest-creator'],
    allowNotebookCompletion: true
  },
  nextLessonId: 'anita-week-9-day-5'
};

export default day4;
